import { DropdownOption } from '@equip.health/ui';

const SMTPermissionTypeValue: Record<SMTPermissionType, SMTPermissionType> = {
  ADD: 'ADD',
  NO_ACCESS: 'NO_ACCESS',
  VIEW: 'VIEW',
};

const PermissionTypeMap: Record<SMTPermissionType, string> = {
  ADD: 'Add and view entries',
  NO_ACCESS: 'No access',
  VIEW: 'View only',
};

const SMTEntryType: Record<string, SMTEntryType> = {
  Meal: 'MEAL',
};

const SMTPermissions: SMTPermissionType[] = [
  SMTPermissionTypeValue.ADD,
  SMTPermissionTypeValue.VIEW,
  SMTPermissionTypeValue.NO_ACCESS,
];

const SMTPermissionsDropdownOptions: DropdownOption[] = SMTPermissions.map(
  (permission) => ({
    label: PermissionTypeMap[permission],
    value: permission,
  }),
);

/**
 * Image compression constants for SMT entries
 * Optimized to target 400-600KB file size range with balanced quality
 */
const SMTImageCompression = {
  /** Initial quality setting (85% - library adjusts iteratively) */
  initialQuality: 0.85,
  /** Maximum dimension in pixels (max width or height) */
  maxDimension: 1920,
  /** Maximum file size in MB (600KB target - library optimizes to ~400-600KB range) */
  maxSizeMB: 0.6,
} as const;

export {
  PermissionTypeMap,
  SMTPermissionTypeValue,
  SMTEntryType,
  SMTPermissions,
  SMTPermissionsDropdownOptions,
  SMTImageCompression,
};
